export class TimedCache<T> {
  private value?: T;
  private lastRefreshEpochMillis = 0;

  constructor(
    private readonly timeoutDurationMillis: number,
    private readonly getter: () => Promise<T>,
  ) {}

  clear(): void {
    this.value = undefined;
    this.lastRefreshEpochMillis = 0;
  }

  async getValue(): Promise<T> {
    if (this.value && Date.now() - this.lastRefreshEpochMillis < this.timeoutDurationMillis) {
      return this.value;
    }
    this.value = await this.getter();
    this.lastRefreshEpochMillis = Date.now();
    return this.value;
  }

  setValue(value: T): void {
    this.value = value;
    this.lastRefreshEpochMillis = Date.now();
  }
}
